<footer class="footer">
  <div class="footer__wrapper">
    <section class="footer__wrapper-logo">
      <picture>
        <source srcset="resources/img/logos-titles/logoIberFooter_mobile.png" media="(max-width: 1330px)" />
        <img class="footer__wrapper-logo--PC" src="resources/img/logos-titles/logoIberFooter_PC.png" alt="Ibercon logo" />
      </picture>
    </section>

    <section class="footer__wrapper-policies">
      <ul class="footer__wrapper-policies--list">
        <li>
          <h2>
            <strong>{{ 'shared.footer.policies.title' | translate }}</strong>
          </h2>
        </li>
        <li>
          <a routerLink="./policies/account">{{ 'shared.footer.policies.accountCreationPolicy' | translate }}</a>
        </li>
        <li>
          <a routerLink="./policies/tickets">{{ 'shared.footer.policies.ticketPurchaseTerms' | translate }}</a>
        </li>
        <li>
          <a routerLink="./policies/privacy">{{ 'shared.footer.policies.privacyPolicy' | translate }}</a>
        </li>
        <li>
          <a routerLink="./policies/cookies">{{ 'shared.footer.policies.cookiePolicy' | translate }}</a>
        </li>
        <li>
          <a routerLink="./policies/legal">{{ 'shared.footer.policies.legalNotice' | translate }}</a>
        </li>
        <!-- <li>
          <a href="./policies/rules">{{ 'shared.footer.policies.rules' | translate }}</a> // TODO: ADD AFTER THIS IS DONE
        </li> -->
      </ul>
    </section>

    <section class="footer__wrapper-tickets">
      <ul class="footer__wrapper-tickets--list">
        <li>
          <h2>
            <strong>{{ 'shared.footer.tickets.title' | translate }}</strong>
          </h2>
        </li>
        <li>
          <a routerLink="event/tickets">{{ 'shared.footer.tickets.content' | translate }}</a>
        </li>
      </ul>
    </section>

    <section class="footer__wrapper-contact">
      <ul class="footer__wrapper-contact--list">
        <li>
          <h2>
            <strong>{{ 'shared.footer.contact' | translate }}</strong>
          </h2>
        </li>
        <li>
          <section class="footer__wrapper-contact--socials">
            <a class="footer__wrapper-contact--bluesky" href="https://bsky.app/profile/ibercon.org" target="_blank">
              <img class="footer__main-badge" src="resources/img/rrss/bluesky.png" alt="BlueSky logo" />
            </a>
            <a class="footer__wrapper-contact--telegram" href="https://t.me/IberconOficial" target="_blank">
              <img class="footer__main-badge" src="resources/img/rrss/telegram.png" alt="Telegram logo" />
            </a>

            <a class="footer__wrapper-contact--twitter" href="https://x.com/IberconOficial" target="_blank">
              <img class="footer__main-badge" src="resources/img/rrss/twitter.png" alt="Twitter logo" />
            </a>
            <a class="footer__wrapper-contact--tiktok" href="https://www.tiktok.com/@ibercon" target="_blank">
              <img class="footer__main-badge" src="resources/img/rrss/tiktok.png" alt="Tiktok logo" />
            </a>
          </section>
        </li>
      </ul>
    </section>
  </div>

  <div class="footer__separator">
    <hr />
  </div>

  <div class="footer__section">
    <section class="footer__acfe">
      <small>{{ 'shared.footer.copyright.acfe' | translate }}</small>
    </section>
    <section class="footer__copyright">
      <small>{{ 'shared.footer.copyright.rights' | translate }}</small>
    </section>
    <section class="footer__it">
      <small>{{ 'shared.footer.it.message' | translate }}</small>
    </section>
    <section class="footer__zonahosting">
      <small>Sponsored by:</small>
    </section>
    <section class="footer__iberia">
      <a href="https://www.iberia.com" target="_blank">
        <img src="resources/img/icons/iberia.jpeg" alt="Iberia logo" />
      </a>
      <a href="https://zonahosting.us/u/ibercon" target="_blank">
        <img src="resources/img/icons/zonahosting.png" alt="ZonaHosting logo" />
      </a>
    </section>
  </div>
</footer>
